module.exports = __webpack_public_path__ + "assets/img/ny.54147240.png";